/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AOMGH5ReceivedPlugin
 */

import { ITracker } from 'com/didichuxing/tracker/ITracker';
import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import { ITrackedEventArgs } from 'com/didichuxing/tracker/plugin/IReportingStrategyPlugin';
import { ITrackerConfiguration } from 'com/didichuxing/tracker/config/ITrackerConfiguration';
import AReportingStrategyPlugin from 'com/didichuxing/tracker/plugin/AReportingStrategyPlugin';
import PluginUtils from 'com/didichuxing/tracker/plugin/utils/PluginUtils';
import OMGH5ReceivedEvent from 'com/didichuxing/tracker/h5/plugins/events/OMGH5ReceivedEvent';

export default abstract class AOMGH5ReceivedPlugin extends AReportingStrategyPlugin {

    /**
     * @override
     * @returns {string}
     */
    public getName(): string {
        return PluginUtils.PLUGIN_NAME_RECEIVED;
    }

    /**
     * 对tracker.setConfig进行拦截。
     * @param {ITrackerConfiguration} config
     */
    private adviceSetConfigHandler(config: ITrackerConfiguration): void {
        if (config.userName || config.userId || config.telephone || config.cityId) { // 只有设置了用户名、uid或者手机号才进行该事件上报。
            this.report( {
                eventId: PluginUtils.EVENT_ID_RECEIVED,
                attrs: {}
            });
        }
    }

    /**
     * @override
     * @inheritDoc
     * @returns {boolean}
     */
    public install(): boolean {
        const tracker: ITracker = this.getTracker();
        const setConfigHandler: (config: ITrackerConfiguration) => void = tracker.setConfig;
        tracker.setConfig = (config: ITrackerConfiguration): void => {
            setConfigHandler.call(tracker, config);
            this.adviceSetConfigHandler(config);
        };
        return super.install();
    }

    /**
     * @override
     * @inheritDoc
     */
    public execute(): void {
        /* Nothing to execute */
    }

    /**
     * @override
     * @inheritDoc
     */
    public exit(): void {
        /* Nothing to exit */
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITrackedEventArgs} eventArgs
     * @returns {ITrackedEvent}
     */
    protected generateEvent(eventArgs: ITrackedEventArgs): ITrackedEvent {
        return new OMGH5ReceivedEvent(eventArgs.attrs, this.getContext());
    }

    /**
     * @override
     * @inheritDoc
     * @returns {boolean}
     */
    public uninstall(): boolean {
        this.adviceSetConfigHandler = (config: ITrackerConfiguration): void => {/* empty method */};
        return super.uninstall();
    }
}
